import { Action } from '@ngrx/store';
import { ShippingLocationMode } from '../models/shipping-location-mode.model';

export enum OneClickShippingModeActionTypes {
  LOAD = '[One Click] Load shipping modes',
  LOAD_COMPLETE = '[One Click] Load shipping modes completed',
  SELECT = '[One Click] Select shipping modes',
  RESET = '[One Click] Shipping modes reset',
}

export class OneClickLoadShippingModeAction implements Action {
  readonly type = OneClickShippingModeActionTypes.LOAD;

  constructor() {}
}

export class OneClickLoadShippingModeCompleteAction implements Action {
  readonly type = OneClickShippingModeActionTypes.LOAD_COMPLETE;

  constructor(public payload: ShippingLocationMode[]) {}
}

export class OneClickSelectShippingModeAction implements Action {
  readonly type = OneClickShippingModeActionTypes.SELECT;

  constructor(public payload: ShippingLocationMode) {}
}

export class OneClickResetShippingModeAction implements Action {
  readonly type = OneClickShippingModeActionTypes.RESET;

  constructor() {}
}

export type OneClickShippingModeActions =
  | OneClickLoadShippingModeAction
  | OneClickLoadShippingModeCompleteAction
  | OneClickSelectShippingModeAction
  | OneClickResetShippingModeAction;
